// Wins Style — scripts propios (prefijo mt-)
document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
  initVariantesProducto();
  initFaq();
  initTilt();
  initComparador();
  initCuentaAtras();
});

// Cuenta atrás de drops. La fecha se escribe en hora de Ciudad de México (UTC-6).
function initCuentaAtras() {
  var cuentas = document.querySelectorAll('[data-mt-cuenta]');
  cuentas.forEach(function (el) {
    var txt = (el.getAttribute('data-mt-cuenta') || '').trim();
    var m = txt.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) { el.hidden = true; return; }
    var fin = Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) + 6, +m[5] || 0);
    var d = el.querySelector('[data-mt-d]'), h = el.querySelector('[data-mt-h]');
    var mi = el.querySelector('[data-mt-m]'), s = el.querySelector('[data-mt-s]');
    var dos = function (n) { return (n < 10 ? '0' : '') + n; };
    function pintar() {
      var resto = Math.max(0, Math.floor((fin - Date.now()) / 1000));
      d.textContent = dos(Math.floor(resto / 86400));
      h.textContent = dos(Math.floor(resto % 86400 / 3600));
      mi.textContent = dos(Math.floor(resto % 3600 / 60));
      s.textContent = dos(resto % 60);
      if (resto === 0) {
        clearInterval(reloj);
        var titulo = el.querySelector('[data-mt-cuenta-titulo]');
        var textoFin = el.getAttribute('data-texto-fin');
        if (titulo && textoFin) titulo.textContent = textoFin;
        el.classList.add('mt-cuenta--fin');
      }
    }
    var reloj = setInterval(pintar, 1000);
    pintar();
  });
}

function initComparador() {
  var marcos = document.querySelectorAll('[data-mt-comparador]');
  marcos.forEach(function (marco) {
    var rango = marco.querySelector('[data-mt-comparador-rango]');
    var despues = marco.querySelector('[data-mt-comparador-despues]');
    var asa = marco.querySelector('[data-mt-comparador-asa]');
    if (!rango || !despues || !asa) return;

    function fijarValor(v) {
      v = Math.max(0, Math.min(100, v));
      rango.value = v;
      despues.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      asa.style.left = v + '%';
    }

    function valorDesdeX(clientX) {
      var rect = marco.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var arrastrando = false;

    marco.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      if (marco.setPointerCapture) marco.setPointerCapture(e.pointerId);
      fijarValor(valorDesdeX(e.clientX));
    });
    marco.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijarValor(valorDesdeX(e.clientX));
    });
    function soltar(e) {
      arrastrando = false;
      if (marco.releasePointerCapture) {
        try { marco.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
    }
    marco.addEventListener('pointerup', soltar);
    marco.addEventListener('pointercancel', soltar);

    rango.addEventListener('input', function () { fijarValor(rango.value); });
    rango.addEventListener('wheel', function (e) {
      e.preventDefault();
      window.scrollBy(0, e.deltaY);
    }, { passive: false });

    fijarValor(rango.value);
  });
}

function initTilt() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  var tarjetas = document.querySelectorAll('.mt-tarjeta, .mt-paso__figura');
  tarjetas.forEach(function (el) {
    el.style.willChange = 'transform';
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = 'perspective(800px) rotateX(' + (y * -5) + 'deg) rotateY(' + (x * 5) + 'deg) translateY(-4px)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
    });
  });
}

function initRevelado() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  elementos.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      });
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-mt-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioAntesEl = form.querySelector('[data-mt-precio-antes]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    var botones = form.querySelectorAll('[data-mt-opcion]');
    var cantidadInput = form.querySelector('[data-mt-cantidad-input]');

    function ajustarCantidad(paso) {
      var valor = (parseInt(cantidadInput.value, 10) || 1) + paso;
      var max = parseInt(cantidadInput.max, 10);
      if (max && valor > max) valor = max;
      if (valor < 1) valor = 1;
      cantidadInput.value = valor;
    }

    if (cantidadInput) {
      form.querySelector('[data-mt-cantidad-menos]').addEventListener('click', function () { ajustarCantidad(-1); });
      form.querySelector('[data-mt-cantidad-mas]').addEventListener('click', function () { ajustarCantidad(1); });
      cantidadInput.addEventListener('change', function () { ajustarCantidad(0); });
    }

    function estadoSeleccionado() {
      var seleccion = {};
      form.querySelectorAll('[data-mt-opcion].mt-activa').forEach(function (btn) {
        seleccion[btn.getAttribute('data-opcion-nombre')] = btn.getAttribute('data-opcion-valor');
      });
      return seleccion;
    }

    function buscarVariante(seleccion) {
      return variantes.find(function (v) {
        return v.opciones.every(function (opt) { return seleccion[opt.nombre] === opt.valor; });
      });
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function actualizar() {
      var seleccion = estadoSeleccionado();
      var variante = buscarVariante(seleccion);
      if (!variante) return;
      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.precio);
      if (precioAntesEl) {
        if (variante.precioAntes && variante.precioAntes > variante.precio) {
          precioAntesEl.textContent = formatearDinero(variante.precioAntes);
          precioAntesEl.hidden = false;
        } else {
          precioAntesEl.hidden = true;
        }
      }
      var descEl = form.querySelector('[data-mt-descuento]');
      if (descEl) {
        if (variante.precioAntes && variante.precioAntes > variante.precio) {
          descEl.textContent = '-' + Math.floor((variante.precioAntes - variante.precio) * 100 / variante.precioAntes) + '%';
          descEl.hidden = false;
        } else {
          descEl.hidden = true;
        }
      }
      var avisoTalla = form.querySelector('[data-mt-aviso-talla]');
      if (avisoTalla) {
        var umbral = parseInt(avisoTalla.getAttribute('data-umbral'), 10) || 0;
        if (variante.disponible && variante.stock !== null && variante.stock > 0 && variante.stock <= umbral) {
          avisoTalla.textContent = avisoTalla.getAttribute('data-texto').replace('[x]', variante.stock);
          avisoTalla.hidden = false;
        } else {
          avisoTalla.hidden = true;
        }
      }
      if (cantidadInput) {
        if (variante.stock !== null && variante.stock > 0) {
          cantidadInput.max = variante.stock;
        } else {
          cantidadInput.removeAttribute('max');
        }
        ajustarCantidad(0);
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.disponible;
        botonComprar.textContent = variante.disponible
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
    }

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.getAttribute('data-opcion-nombre');
        form.querySelectorAll('[data-opcion-nombre="' + grupo + '"]').forEach(function (b) {
          b.classList.remove('mt-activa');
        });
        btn.classList.add('mt-activa');
        actualizar();
      });
    });

    actualizar();
  });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  items.forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!pregunta || !respuesta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-abierta');
      items.forEach(function (i) {
        i.classList.remove('mt-abierta');
        i.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierta) {
        item.classList.add('mt-abierta');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}
